function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f0f0f;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M92.733,11.4a5.516,5.516,0,0,0,4.031-1.67A5.516,5.516,0,0,0,98.434,5.7a5.517,5.517,0,0,0-1.67-4.031,5.7,5.7,0,0,0-8.062,0A5.516,5.516,0,0,0,87.032,5.7,5.516,5.516,0,0,0,88.7,9.732,5.517,5.517,0,0,0,92.733,11.4Zm0,0",
  transform: "translate(-83.176 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M19.353,254.084a14.319,14.319,0,0,0-.188-1.5,11.959,11.959,0,0,0-.361-1.5,7.5,7.5,0,0,0-.607-1.4,5.282,5.282,0,0,0-.916-1.215,4.029,4.029,0,0,0-1.315-.841,4.476,4.476,0,0,0-1.679-.309,1.688,1.688,0,0,0-.91.393c-.273.181-.592.391-.948.622a5.387,5.387,0,0,1-1.227.55,4.685,4.685,0,0,1-3,0,5.374,5.374,0,0,1-1.226-.55c-.353-.23-.672-.439-.949-.623a1.686,1.686,0,0,0-.91-.393,4.47,4.47,0,0,0-1.679.31,4.025,4.025,0,0,0-1.316.841,5.283,5.283,0,0,0-.915,1.215,7.51,7.51,0,0,0-.607,1.4,11.986,11.986,0,0,0-.361,1.5,14.269,14.269,0,0,0-.188,1.5c-.031.453-.046.923-.046,1.4a3.968,3.968,0,0,0,1.147,2.974,4.086,4.086,0,0,0,2.955,1.1H15.3a4.086,4.086,0,0,0,2.955-1.1,3.966,3.966,0,0,0,1.147-2.974c0-.477-.016-.947-.047-1.4Zm0,0",
  transform: "translate(0 -236.299)"
});

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.4,
    height: 23.254,
    viewBox: "0 0 19.4 23.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.912c6961.svg";
export { ForwardRef as ReactComponent };